//REDUX-TOOLKIT
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

// COMMISSION_WALLET
// PURCHASE_WALLET
interface State {
    shopProviders: any
    shopMethods: any
    products: any
    purchases: any
}

const initialState: State = {
    shopProviders: null,
    shopMethods: null,
    products: null,
    purchases: null
}

const slice = createSlice({
    name: "shop",
    initialState,
    reducers: {
        setProviders: (state, action: PayloadAction<any>) => {
            return { ...state, shopProviders:action.payload }
        },
        setMethods: (state, action: PayloadAction<any>) => {
            return { ...state, shopMethods:action.payload }
        },
        setProducts: (state, action: PayloadAction<any>) => {
            return { ...state, products:action.payload }
        },
        setPurchases: (state, action: PayloadAction<any>) => {
            return { ...state, purchases:action.payload }
        }
    },
})

export const {
    setProviders,
    setMethods,
    setProducts,
    setPurchases
} = slice.actions
export const selectShop = (state: { shop: State }) => state.shop
export default slice.reducer
